import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function Executor() {
    const {
        executor, setExecutor,
        listExecutors
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Executor Responsável:
            </Typography>

            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setExecutor(e.target.value)}
                    value={executor}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    {listExecutors.filter(res => res.name !== 'Todos').map((res, idx) => (
                        <MenuItem value={res.name} key={idx}>
                            {res.name}
                        </MenuItem>)
                    )}
                </Select>
            </FormControl>
        </>
    );
}
